import React, { useEffect, useState } from 'react'
import introdata from './HomeApi.json'
import HomeDataLoad from './HomeDataLoad';
const Home = () => {
    const [intros,setIntro] = useState([]);
    
    useEffect(()=>{
        setIntro(introdata)
        console.log(setIntro)

    },[])
    return (
        <div className="container px-10 mx-auto my-20 ">
        
            <div>
            {
                intros.map((datain) =>( <HomeDataLoad intro={datain}/>) )
            }
            </div>
            


        </div>
        
    )
}

export default Home
